import React from 'react'

const BankruptcyPartiesRow = ({meta}) => (
    <tr>
        <td>{meta.party_name}</td>
        <td>{meta.party_role}</td>
        <td>{meta.court_code}</td>
        <td className="ir-search-no-wrap"><a href={"/filings/" + meta.case_uuid} target="_blank">{meta.case_no}</a></td>
        <td>{meta.chapter}</td>
        <td>{meta.date_filed}</td>
        <td>{meta.date_closed}</td>
        <td>{meta.disposition}</td>
    </tr>
)

export default BankruptcyPartiesRow



/** WEBPACK FOOTER **
 ** ./src/components/search/results/BankruptcyPartiesRow.js
 **/